export const dataURLtoFile = (dataUrl: string, filename: string): File => {
  const arr = dataUrl.split(",");
  let mimeType;
  const mimeTypeMatches = arr[0].match(/:(.*?);/);
  if (mimeTypeMatches?.length) {
    mimeType = mimeTypeMatches[1];
  }

  const bStr = atob(arr[1]);
  let bStrLength = bStr.length;
  const u8arr = new Uint8Array(bStrLength);

  while (bStrLength--) {
    u8arr[bStrLength] = bStr.charCodeAt(bStrLength);
  }

  return new File([u8arr], filename, { type: mimeType });
};

export const downloadBlob = (blob: Blob, name: string) => {
  // Create a temporary element
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = window.URL.createObjectURL(blob);
  link.download = name;

  document.body.appendChild(link);
  link.click();
  // Remove element
  document.body.removeChild(link);
};

export const base64toCSVString = (base64: string) => {
  return window.atob(base64);
};

export const base64toCSVFile = (base64: string) => {
  const decoded = base64toCSVString(base64);
  const contentType = "text/csv";

  return new Blob([decoded], { type: contentType });
};

export const getPlaceholderFile = (fileName = "logo.png") => {
  return new File([], fileName);
};
